import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'recompose';
import { addBroadcastAffiliation } from '../actions';

type IOwnProps = RouteComponentProps;

const mapDispatchToProps = {
  addBroadcastAffiliation,
};

const mapStateToProps = () => ({});

export type IComponentProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  InjectedIntlProps &
  IOwnProps;

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);

export const connector = compose<IComponentProps, IOwnProps>(reduxConnector, injectIntl);
